import { render, staticRenderFns } from "./MyNewsletter.vue?vue&type=template&id=4f6bd5cd&scoped=true&"
import script from "./MyNewsletter.vue?vue&type=script&lang=ts&"
export * from "./MyNewsletter.vue?vue&type=script&lang=ts&"
import style0 from "./MyNewsletter.vue?vue&type=style&index=0&id=4f6bd5cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6bd5cd",
  null
  
)

export default component.exports